const routes = {
  CERTIFICATE: '/certification/:certId',
  INDEX: '/',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
  RESET_PASSWORD: '/reset-password',
  FORGOT_PASSWORD: '/forgot-password',
  VERIFY_EMAIL: '/verify-email',
  MEMBERSHIP: '/membership',
  PROGRAMS: '/programs',
  MEMBER_CERTIFICATE: '/certificate',
  COURSES: '/programs/:programId/:curriculumId/courses',
  COURSES_WITH_ID: '/programs/:programId/:curriculumId/courses/:courseId',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  PROGRESS: '/progress',
  MANAGE: '/manage',
  MEMBER: '/member/:memberId',
  SIGN_OUT: '/logout',
};

export default routes;
